var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{class:_vm.buttonClass,style:(_vm.customStyle),attrs:{"loading":_vm.dataDisable},on:{"click":function($event){return _vm.submit()}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }